module.exports = __webpack_public_path__ + "static/alex-55134c83ac5ce586709a27d5b94681a1.jpg";